export default {
  title: 'Microaudiencia Proyectada vs Diferencia Última Ola (%)',
  infoDialog: 'Tendencia de la contribución estimada de KPI por microaudiencias (diferencia proyectada vs último período)',
  kpi: 'KPI'
}
